// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-layers-MapFeaturePopup-module__popup {
    background-color: white;
    font-size: small;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    padding: 5px 10px 5px 10px;
    border-radius: 10px;
}

.src-layers-MapFeaturePopup-module__poiPopup {
    position: relative;
    top: -40px;
    left: 20px;
    max-width: 300px;

    background-color: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    padding: 5px 10px 5px 10px;
    border-radius: 10px;
}

.src-layers-MapFeaturePopup-module__poiPopup div:first-child {
    font-weight: bold;
    padding-bottom: 5px;
}

.src-layers-MapFeaturePopup-module__poiPopupButton {
    display: flex;
    flex-direction: row;
    gap: 7px;
    padding-top: 12px;
    padding-bottom: 8px;
}

.src-layers-MapFeaturePopup-module__poiPopupButton svg {
    margin-top: 3px;
}

.src-layers-MapFeaturePopup-module__poiPopup a {
    color: gray;
    text-decoration: none;
}

.src-layers-MapFeaturePopup-module__poiPopup a:hover {
    color: black;
    text-decoration: underline;
}

.src-layers-MapFeaturePopup-module__poiPopupTable {
    font-size: small;
    padding: 6px 0;
}

.src-layers-MapFeaturePopup-module__osmLink {
    padding-bottom: 7px;
}

.src-layers-MapFeaturePopup-module__osmLink a {
    font-size: small;
}

.src-layers-MapFeaturePopup-module__poiPopupTable th,
.src-layers-MapFeaturePopup-module__poiPopupTable td {
    border-bottom: 1px solid #ccc;
    padding: 3px 1px 3px 0;
    text-align: left;

    /* strange, why do we need the following? */
    word-break: break-all;
    min-width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/layers/MapFeaturePopup.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,wCAAwC;IACxC,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,gBAAgB;;IAEhB,uBAAuB;IACvB,wCAAwC;IACxC,sBAAsB;IACtB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,6BAA6B;IAC7B,sBAAsB;IACtB,gBAAgB;;IAEhB,2CAA2C;IAC3C,qBAAqB;IACrB,gBAAgB;AACpB","sourcesContent":[".popup {\n    background-color: white;\n    font-size: small;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\n    padding: 5px 10px 5px 10px;\n    border-radius: 10px;\n}\n\n.poiPopup {\n    position: relative;\n    top: -40px;\n    left: 20px;\n    max-width: 300px;\n\n    background-color: white;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\n    box-sizing: border-box;\n    padding: 5px 10px 5px 10px;\n    border-radius: 10px;\n}\n\n.poiPopup div:first-child {\n    font-weight: bold;\n    padding-bottom: 5px;\n}\n\n.poiPopupButton {\n    display: flex;\n    flex-direction: row;\n    gap: 7px;\n    padding-top: 12px;\n    padding-bottom: 8px;\n}\n\n.poiPopupButton svg {\n    margin-top: 3px;\n}\n\n.poiPopup a {\n    color: gray;\n    text-decoration: none;\n}\n\n.poiPopup a:hover {\n    color: black;\n    text-decoration: underline;\n}\n\n.poiPopupTable {\n    font-size: small;\n    padding: 6px 0;\n}\n\n.osmLink {\n    padding-bottom: 7px;\n}\n\n.osmLink a {\n    font-size: small;\n}\n\n.poiPopupTable th,\n.poiPopupTable td {\n    border-bottom: 1px solid #ccc;\n    padding: 3px 1px 3px 0;\n    text-align: left;\n\n    /* strange, why do we need the following? */\n    word-break: break-all;\n    min-width: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `src-layers-MapFeaturePopup-module__popup`,
	"poiPopup": `src-layers-MapFeaturePopup-module__poiPopup`,
	"poiPopupButton": `src-layers-MapFeaturePopup-module__poiPopupButton`,
	"poiPopupTable": `src-layers-MapFeaturePopup-module__poiPopupTable`,
	"osmLink": `src-layers-MapFeaturePopup-module__osmLink`
};
export default ___CSS_LOADER_EXPORT___;
